import { addons } from "@storybook/addons";
import caiosbTheme from "./caiosb";

addons.setConfig({
  theme: caiosbTheme,
});
